<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';
import AccountActivityItem from '../AccountActivityItem/AccountActivityItem.vue';
import PaginationControl from '../PaginationControl/PaginationControl.vue';
import DropDownMenu from '../DropdownMenu/DropdownMenu.vue'

export default Vue.extend({
    components: {
        AccountActivityItem,
        PaginationControl,
        DropDownMenu
    },
    computed: {
        ...mapState({
            limit: state => state.account.activity.limit,
            limits: state => state.account.activity.limits,
            page: state => state.account.activity.page
        }),
        ...mapGetters({
            activityPaginated: 'account/activityPaginated',
            activityMaxPages: 'account/activityMaxPages',
        })
    },
    methods: {
        ...mapActions({
            setRows: 'account/setRows',
            activityPageIncrement: 'account/activityPageIncrement',
            activityPageDecrement: 'account/activityPageDecrement',
        })
    }
});
</script>

<template>
    <div class="account-activity">
        <div class="account-activity__header">
            <div class="account-activity__heading">
                {{ $t('account.activity.header.heading') }}
            </div>
            <div class="account-activity__filter">
                <drop-down-menu
                    :label="$t('account.activity.limit')"
                    :value="limit"
                    :items="limits"
                    :searchable="false"
                    @input="setRows($event)"/>
            </div>
            <div class="account-activity__months">
                {{ $t('account.activity.header.months') }}
            </div>
        </div>
        <table class="table account-activity__table">
            <thead class="account-activity__table-head">
                <tr>
                    <th>{{ $t('account.activity.date') }}</th>
                    <th>{{ $t('account.activity.type.label') }}</th>
                    <th>{{ $t('account.activity.accommodation') }}</th>
                    <th>{{ $t('account.activity.site') }}</th>
                    <th>{{ $t('account.activity.status.label') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(activity, index) in activityPaginated" :key="index">
                    <td>{{ activity.updatedAt | moment("DD/MM/Y\, HH:mm") }}</td>
                    <td>{{ $t('account.activity.type.' + activity.type) }}</td>
                    <td>{{ activity.accommodation }}</td>
                    <td>{{ activity.site }}</td>
                    <td>{{ $t('account.activity.status.' + activity.status) }}</td>
                </tr>
            </tbody>
        </table>
        <div v-if="!activityPaginated" class="account-activity__no-content">
            <i class="fa fa-bullhorn"/>
            <div class="manage-allocation-list__error-message">{{ $t('dashboard.notifications.noContent') }}</div>
        </div>
        <div class="account-activity__items">
            <div class="account-activity__items-list">
                <account-activity-item v-for="(activity, index) in activityPaginated"
                                       :key="index"
                                       :type="activity.type"
                                       :accommodation="activity.accommodation"
                                       :site="activity.site"
                                       :status="activity.status"
                                       :date="activity.updatedAt"
                />
            </div>
        </div>
        <div v-if="activityPaginated" class="account-activity__footer">
            <div class="account-activity__pagination">
                <pagination-control :max-pages="activityMaxPages"
                                    :current-page="page"
                                    @prev="activityPageDecrement"
                                    @next="activityPageIncrement"/>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AccountActivity/AccountActivity.vue